import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';
import { InPersonSession } from '@app/features/inPerson/types';

export interface PostStartInPersonSessionResponse {
  occupied: boolean;
  session: InPersonSession;
}

/**
 * POST postStartInPersonSession
 *
 */
export function postStartInPersonSession({
  documentId,
  participantId,
  workspaceId,
}: {
  documentId: string;
  participantId: string;
  workspaceId: string;
}) {
  return requestApi<PostStartInPersonSessionResponse>({
    url: withDocument(
      `/workspaces/${workspaceId}/documents/${documentId}/participants/${participantId}/session`
    ),
    method: 'POST',
    data: {
      participantId,
    },
    credentials: true,
  }).then((res) => res.data);
}

/**
 * DELETE deleteInPersonSession
 *
 */
export function deleteInPersonSession({
  documentId,
  participantId,
  workspaceId,
}: {
  documentId: string;
  participantId: string;
  workspaceId: string;
}) {
  return requestApi({
    url: withDocument(
      `/workspaces/${workspaceId}/documents/${documentId}/participants/${participantId}/session`
    ),
    method: 'DELETE',
    data: {
      participantId,
    },
    credentials: true,
  });
}
